import './App.css';
import Router from './router/router';
// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";
// Bootstrap Bundle JS
import "bootstrap/dist/js/bootstrap.bundle.min";
import store from "./redux/store";
import {Provider, useDispatch, useSelector} from "react-redux";
import ReactGA from './analytics';
import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { upgradeToPro } from "./redux/userSlice";
import { useLazyGetPaymentStatusQuery } from "./redux/service/paymntService";

// Safety net: if a PayHere order was started but never confirmed as Pro on
// the client (poll window expired, or the user left the return page before
// it finished), resolve it here on the next app load instead of leaving the
// user stuck until they log out/in.
function PendingPayHereResolver() {
    const dispatch = useDispatch();
    const isPro = useSelector((state) => state.user.isPro);
    const [triggerGetStatus] = useLazyGetPaymentStatusQuery();

    useEffect(() => {
        if (isPro) return;
        const orderId = localStorage.getItem("payhere_last_order_id");
        if (!orderId) return;

        let cancelled = false;
        (async () => {
            try {
                const json = await triggerGetStatus(orderId).unwrap();
                if (!cancelled && json?.success && json?.data?.isProUser === true) {
                    dispatch(upgradeToPro());
                    localStorage.removeItem("payhere_last_order_id");
                }
            } catch (e) {
                // leave the pending order id in place, try again next app load
            }
        })();

        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
}

function App() {

    const location = useLocation();

    useEffect(() => {
        ReactGA.send({
            hitType: "pageview",
            page: location.pathname + location.search,
        });
    }, [location]);

    return (
        <>
            <ToastContainer position="top-right" autoClose={2500} />
            <Provider store={store}>

                <div className="App">
                    {/* <Paper/> */}
                    <PendingPayHereResolver />
                    <Router/>
                </div>
            </Provider>
        </>

    );
}

export default App;
